// Bloqueo de primer acceso (LOPDP): si el usuario tiene mustChangePassword
// (clave fijada por el staff al crear el acceso del portal), debe cambiarla
// antes de operar. Cubre pantalla completa hasta que la cambie.
import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ShieldAlert, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { authAPI } from '@/lib/api/auth.api';
import { getErrorMessage } from '@/lib/api/client';

const inputCls = 'w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring';

export function CambiarClaveGate() {
  const qc = useQueryClient();
  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [confirmar, setConfirmar] = useState('');

  const cambiar = useMutation({
    mutationFn: () => authAPI.cambiarClave(actual, nueva),
    onSuccess: () => {
      toast.success('Clave actualizada. Bienvenido/a.');
      void qc.invalidateQueries({ queryKey: ['currentUser'] });
    },
    onError: (e) => toast.error(getErrorMessage(e)),
  });

  const errNueva = nueva.length > 0 && nueva.length < 8 ? 'Mínimo 8 caracteres' : '';
  const errConf = confirmar.length > 0 && confirmar !== nueva ? 'No coincide' : '';
  const puede = actual.length > 0 && nueva.length >= 8 && confirmar === nueva;

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-4 rounded-xl border bg-card p-6 shadow-lg">
        <div className="flex items-center gap-3">
          <div className="rounded-full bg-pendiente-soft p-2 text-pendiente"><ShieldAlert className="h-6 w-6" /></div>
          <div>
            <h1 className="text-lg font-semibold">Cambia tu clave para continuar</h1>
            <p className="text-sm text-muted-foreground">Por seguridad de tus datos personales (LOPDP), debes establecer una clave nueva en tu primer acceso.</p>
          </div>
        </div>
        <div className="space-y-3">
          <div>
            <label className="text-xs text-muted-foreground">Clave actual (la que te entregaron)</label>
            <input type="password" className={inputCls} value={actual} onChange={(e) => setActual(e.target.value)} autoComplete="current-password" />
          </div>
          <div>
            <label className="text-xs text-muted-foreground">Clave nueva</label>
            <input type="password" className={inputCls} value={nueva} onChange={(e) => setNueva(e.target.value)} autoComplete="new-password" />
            {errNueva && <p className="text-xs text-urgente mt-1">{errNueva}</p>}
          </div>
          <div>
            <label className="text-xs text-muted-foreground">Confirmar clave nueva</label>
            <input type="password" className={inputCls} value={confirmar} onChange={(e) => setConfirmar(e.target.value)} autoComplete="new-password" />
            {errConf && <p className="text-xs text-urgente mt-1">{errConf}</p>}
          </div>
          <Button className="w-full" disabled={!puede || cambiar.isPending} onClick={() => cambiar.mutate()}>
            {cambiar.isPending && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Guardar y continuar
          </Button>
        </div>
      </div>
    </div>
  );
}
